import React, { useState, useEffect, useRef } from 'react';
import { useOutsideClick } from '../../../utils/custom-hooks';

import Icon from '../../ui/icon';

const OptionsModal = ({ setShowOptionsModal, mod }) => {
  const ref = useRef(false);
  useOutsideClick(ref, () => setShowOptionsModal(false));

  const deleteButton = !mod.is_default ? <div className="delete">Delete</div> : null;

  return (
    <div className="options-modal" ref={node => (ref.current = node)}>
      <div>Edit</div>
      <div>Publish</div>
      {deleteButton}
    </div>
  );
};

const ModuleOptions = ({ mod }) => {
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const modal = showOptionsModal ? (
    <OptionsModal setShowOptionsModal={setShowOptionsModal} mod={mod} />
  ) : null;

  return (
    <div>
      <div
        className={`module-options ${showOptionsModal ? 'open' : ''}`}
        onClick={() => setShowOptionsModal(!showOptionsModal)}
      >
        <Icon iconName="kebab" size={25} />
      </div>
      {modal}
    </div>
  );
};

export default ModuleOptions;
